export const References1 = `<div class=" common-details">
<div class="common-referenceName"></div>
<div class="common-referenceContact"></div>
        </div> `;
